import {get} from 'lodash';

export default (state: any, {isSaving}: any) => ({
  ...state,
  supportedLanguages: {
    ...get(state, 'supportedLanguages', {}),
    isSaving,
  },
});
